import React, { useState, useEffect, useRef } from "react";
import { Button } from "@mui/material";
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import alertIcon from "../../../assets/images/alert.png";
import "./style.css";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        width: '40%',
        maxWidth: 'none',
        minHeight: '250px'
    },
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
        borderTop: "0px",
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

interface AutoSaveModalProps {
    open: boolean;
    closeAutoSave: () => void;
    autoSave: () => void;
}

const AutoSaveModal: React.FC<AutoSaveModalProps> = ({ open, closeAutoSave, autoSave }) => {
    const [timeLeft, setTimeLeft] = useState<number>(30);
    const timerRef = useRef<NodeJS.Timeout | null>(null);
    const hasAutoSaved = useRef(false);


    useEffect(() => {
        // Clear any existing timer when the effect runs
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }

        if (open) {
            hasAutoSaved.current = false;
            setTimeLeft(30);

            timerRef.current = setInterval(() => {
                setTimeLeft(prevTime => {
                    if (prevTime <= 1) {
                        if (timerRef.current) {
                            clearInterval(timerRef.current);
                            timerRef.current = null;
                        }

                        if (!hasAutoSaved.current) {
                            hasAutoSaved.current = true;
                            autoSave();
                        }
                        return 0;
                    }

                    return prevTime - 1;
                });
            }, 1000);
        }

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        };
    }, [open, autoSave]);

    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        };
    }, []);


    return (
        <BootstrapDialog
            aria-labelledby="customized-dialog-title"
            open={open}
        // onClose={closeAutoSave}
        >
            <IconButton
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: '#fff',
                    padding: 0,
                    fontSize: '15px',
                    mt: 1,
                }}
                onClick={closeAutoSave}
            >
                <i className="fas fa-times crose-icon-mt"></i>
            </IconButton>
            <div className="header-bar-top">
                <h3 className="title-head-mdl">Auto Save</h3>
            </div>
            <hr></hr>
            <DialogContent>
                <div className="delete-card-wapper">
                    {/* <div className="icon-delete-wp">
                        <span className="delete-icon-block"><i className="fas fa-exclamation-triangle"></i></span>
                    </div> */}
                    <div className="alert-icon-wp">
                            <img src={alertIcon} alt="" />
                        </div>
                        <br></br>
                    <p className="sub-txt-disc" style={{ marginBottom: "7px" }}>
                        Your project will be saved in {timeLeft} sec
                    </p>
                </div>
            </DialogContent>

            <Stack direction="row" spacing={0} sx={{ justifyContent: "right", py: 1, textAlign: "center" }}>
                <Button
                    variant="contained"
                    className="btn-cancel"
                    sx={{
                        backgroundColor: '#d9d9d9 !important',
                        color: '#626262 !important',
                        borderRadius: '5px',
                        px: 2,
                        py: 1,
                        textTransform: 'capitalize'
                    }}
                    onClick={closeAutoSave}
                >
                    CANCEL
                </Button>
                <Button
                    className="btn-submit"
                    variant="contained"
                    sx={{
                        backgroundColor: '#2a3fbf !important',
                        borderRadius: '5px',
                        px: 2,
                        py: 1,
                        textTransform: 'capitalize',
                        color: '#FFF !important'
                        
                    }}
                    onClick={autoSave}
                >
                    SAVE
                </Button>
            </Stack>
        </BootstrapDialog>
    );
};

export default AutoSaveModal;